"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const OverlayTooltip_1 = tslib_1.__importDefault(require("core/components/OverlayTooltip"));
const DateTime = (props) => {
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(OverlayTooltip_1.default, { content: props.dateTime, direction: props.direction, children: (0, jsx_runtime_1.jsx)("span", { children: props.date }) }) }));
};
exports.default = DateTime;
